@if (textIsLink) {
  <cap-link [capHistinfo]="histInfo" [queryParams]="queryParams" [target]="target" [tooltipParams]="tooltipDetail">
    <ng-container [ngTemplateOutlet]="withoutLink"></ng-container>
  </cap-link>
} @else {
  <ng-container [ngTemplateOutlet]="withoutLink"></ng-container>
}

<ng-template #withoutLink>
  @if (isCollapsed) {
    <span [capHistinfo]="histInfo">
      {{ concatedText.length > limit + MINIMUM_NUMBER_OF_CUTOFF_CHARACTERS ? (concatedText | slice: 0 : limit) + "..." : concatedText }}
    </span>
  } @else {
    @if (text) {
      <span [capHistinfo]="histInfo">
        {{ text }}
      </span>
    } @else {
      <p [capHistinfo]="histInfo" style="margin-bottom: 0px">
        @for (t of texts; track $index) {
          {{ t }}
        }
      </p>
    }
  }
</ng-template>

<a (click)="isCollapsed = !isCollapsed" href="#" id="collapse" onClick="return false;">
  @if (isCollapsable) {
    <span>{{ (isCollapsed ? "MehrAnzeigen" : "WenigerAnzeigen") | translate }}</span>
  }
</a>
